export default __webpack_public_path__ + "c1144ed.png";